export const catalogConfigs = {
  title: {
    default: "DAYOU WINIA E-catalog",
    ko: "대유위니아 전자카탈로그",
  },
  langSet: ["en"],
  pageMap: [
    { name: "cover" },
    { name: "catalog-index" },
    {
      name: "food",
      outlets: [
        "intro",
        {
          name: "dimchae",
          outlets: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
        },
        {
          name: "praud",
          outlets: ["1", "2"],
        },
        {
          name: "mini",
          outlets: ["1", "2", "3"],
        },
        {
          name: "cooker",
          outlets: ["1", "2", "3", "4"],
        },
      ],
    },
    {
      name: "air",
      outlets: [
        "intro",
        {
          name: "purifier",
          outlets: ["1", "2", "3", "4", "5", "6"],
        },
        {
          name: "air-washer",
          outlets: ["1", "2", "3", "4"],
        },
        {
          name: "spowasher",
          outlets: ["1", "2", "3"],
        },
      ],
    },
    {
      name: "clothing",
      outlets: [
        "intro",
        {
          name: "mini-washer",
          outlets: ["1", "2", "3"],
        },
      ],
    },
    "last",
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 0,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
